"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MainBannerSlider = void 0;
var MainBannerSlider_1 = require("./MainBannerSlider");
Object.defineProperty(exports, "MainBannerSlider", { enumerable: true, get: function () { return __importDefault(MainBannerSlider_1).default; } });
